// extracted by mini-css-extract-plugin
export var deleteIcon = "_uf-5";
export var deleteOption = "_uf-3";
export var divider = "_uf-2";
export var downloadIcon = "_uf-4";
export var drawer = "_uf-0";
export var drawerFooter = "_uf-6";
export var drawerOpen = "_uf-1";
export var highlighted = "_uf-7";
export var lighterHighlight = "_uf-8";